export const headingStylesForPanelsAndCards = `.chameleon-text {
  h4 {
    font-size: 1.2rem;
  }
  h5 {
    font-size: 1rem;
  }
  h6 {
    font-size: 0.8rem;
  }
}`;
